/**
 * UnknownKindView — заглушка для незнакомого типа вопроса (Фаза 14, §4 спеки
 * phase-14-interface-spec; решение владельца 2026-10-19).
 *
 * Рендерится default-веткой renderBody в QuestionView, когда questionKind()
 * вернул 'unknown': read-only экран «Обновите клиент» внутри обычной оболочки
 * (прогресс/таймер/title работают — они kind-независимы). Клиент НИЧЕГО не
 * шлёт серверу: отсутствие записи в answers — это и есть «не ответил» (0 очков,
 * reveal/scoreboard приходят всем); tombstone-ответ конфликтовал бы с
 * идемпотентностью first-wins (§4). Работает для клиентов v0.14.0+.
 */
import { useTranslation } from 'react-i18next';
import type { QuestionBodyProps } from './types';

export function UnknownKindView({ question }: QuestionBodyProps): JSX.Element {
  const { t } = useTranslation();
  // Незнакомый kind показываем как есть — помогает владельцу квиза понять,
  // какой новый тип требует обновления клиента.
  const rawKind =
    typeof question.kind === 'string' && question.kind.length > 0 ? question.kind : '?';
  return (
    <div className="unknown-kind-view" data-testid="unknown-kind-screen" role="note">
      <p className="unknown-kind-view__icon" aria-hidden="true">
        🔄
      </p>
      <p className="unknown-kind-view__title">{t('unknown.title')}</p>
      <p className="unknown-kind-view__body">{t('unknown.body')}</p>
      <p className="muted small" data-testid="unknown-kind-raw">
        {t('unknown.kindBadge')} · <code>{rawKind}</code>
      </p>
    </div>
  );
}
